import * as z from "zod/v4";

export const deleteViewFolder = {
  name: "deleteViewFolder" as const,
  input: z.object({ folderId: z.string() }),
  output: z.object({}),
};
